import { useContext } from "react";
import UIkit from "uikit";
import { AppContexts } from "../../../providers";
import Dialog from "../Dialog";

// Shared delete confirmation dialog for rentals
const DeleteRentalDialog = ({ config = {} }) => {
  const {
    title = "Delete Rental",
    onDeleted,
  } = config;

  const { rental, deleteRental } = useContext(AppContexts.RentalsContext);

  const onDelete = async () => {
    const deletedRental = rental;
    try {
      await deleteRental(rental.rental_id);
      UIkit.modal("#modal-property-delete").hide();
      UIkit.notification("Unit deleted successfully", "success");
      if (typeof onDeleted === "function") {
        onDeleted(deletedRental);
      }
    } catch (err) {
      UIkit.modal("#modal-property-delete").hide();
      UIkit.notification("Failed to delete unit", "danger");
    }
  };

  return (
    <Dialog id="modal-property-delete">
      <div className="uk-modal-dialog uk-modal-body">
        <button
          className="uk-modal-close-default"
          type="button"
          uk-close="true"
        ></button>
        <h2 className="uk-modal-title">{title}</h2>
        <p>Are you sure you want to delete?</p>
        <p className="uk-text-right">
          <button
            className="uk-button hms-btn uk-modal-close uk-modal-delete-cancel"
            type="button"
          >
            Cancel
          </button>
          <button
            className="uk-button hms-btn hms-gray-btn"
            type="button"
            onClick={onDelete}
          >
            Delete
          </button>
        </p>
      </div>
    </Dialog>
  );
};

export default DeleteRentalDialog;
